import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useOutletContext } from 'react-router-dom';
import { useAuth } from "../../../context/auth-context";
import { formatDate, formatToZMW, handlePrint, rootUrl } from "../../../helpers";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaPlus, FaPrint, FaReceipt, FaTimes } from "react-icons/fa";
import { FaFileLines, FaUsersGear } from "react-icons/fa6";
import AddBillModal from "../bills/addBill";
import CustomerData from "./customerStatement";
import { customStyles } from "../../../styles";
import Receipt from "../../../components/reciept";


const CustomerPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [transactions, setTransactions] = useState([]);
    const [filteredCashbooks, setFilteredCashbooks] = useState([]);
      const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        bank: '',
        customer: '',
        search: '',
      });
 const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    address: "",
    
  });


  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();

   const componentRef = useRef(null);

  useEffect(() => {

    axios.get(rootUrl(`/getReceipts/${auth.user.id}`)) 
    .then((response) => setTransactions(response.data.data))
    .catch((error) => console.error("Error fetching suppliers:", error));

  }, []); 



  function isAnyValueEmpty(obj) {
    return Object.values(obj).some(value => 
        value === null || value === undefined || value === ''
    );
}

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    formData['uid'] = auth.user.id
    try{
       if(isAnyValueEmpty(formData)){
            toast.error("Please ensure to fill in all fields")
            return
          }
          formData['type'] = 3;
      const response = await axios.post(rootUrl("/addCustomer"), formData)
      if(response.data.status === 200){
        toast.success("Submitted successfully")
        setShowModal(false)
        setFormData(
          {
            name: "",
            contactPerson: "",
            phoneNumber: "",
            email: "",
            address: "",
            
          }
        )

        axios.get(rootUrl(`/getCustomers/${auth.user.id}`)) 
      .then((response) => setAllData((prevData) => ({
        ...prevData, 
        suppliers: response.data.data,
      })))
      .catch((error) => console.error("Error fetching suppliers:", error));

      
      }else{
        toast.info(response.data.msg)
      }

    }catch(e){
      toast.error(e?.message)
    }

  };

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };


  const display = (obj) => {
    openSlidingDiv();
    if (obj.type === 'income') {
      setTitle("Receipt");
      setOutput(<Receipt data={transactions.filter(a=>a.voucher == obj.voucher)} ref={componentRef} />);
    } 
  };

 const columns = [
    {
      name: 'Sn',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '50px',
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.date.substring(0, 10)),
      sortable: true,
    },
    {
      name: 'Chart of Account',
      selector: (row) =>
        allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
      sortable: true,
    },
    {
      name: 'Bank',
      selector: (row) =>
        allData?.bank?.find((a) => a.id === row.bank)?.name || '',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || '',
      sortable: true,
    },
    {
      name: 'Voucher #',
      selector: (row) => row.voucher || '',
      sortable: true,
    },{
      name: 'Cheque #',
      selector: (row) => row.cheque || '',
      sortable: true,
    },
    {
      name: 'Payee',
      selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
        
      ,
      sortable: true,
    },
    {
      name: 'Project',
      selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
      ,
      sortable: true,
    },
    {
      name: 'Debit',
      selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Credit',
      selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Balance',
      selector: (row) => formatToZMW(row.balance || 0),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <>
        <button
          className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
          onClick={() => display(row)}
        >
          <FaEye/>
        </button>
      </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const addPay = (id, type, name) =>{
    if(type === 1){

        setTitle("Add Receipt")
        setOutput(<AddBillModal data={allData} onSubmit={onSubmit} type={1} />)
    }else{

        setTitle("Customer Statement")
        setOutput(<CustomerData id={id} name={name} />)
    }
    openSlidingDiv()

  }

  const onSubmit = async (payload)=>{

        payload['uid'] = auth.user.id
        try{
            const response = await axios.post(rootUrl('/addBillAndPayment'), payload)
            if(response.data.status === 200){
                toast.success("Submitted successfully")
                setShowSlidingDiv(false)
                axios.get(rootUrl(`/getReceipts/${auth.user.id}`)) 
                .then((response) => setTransactions(response.data.data))
                .catch((error) => console.error("Error fetching suppliers:", error));
            
            }else{
                toast.error("Something went wrong")
            }
      
        }catch(e){
            toast.error(e?.message)
        }
    
  }

  useEffect(() => {
    let filtered = transactions;

    if (filters.startDate) {
      filtered = filtered.filter((row) => {
        const rowDate = new Date(row.date);
        const startDate = new Date(filters.startDate);
      
        rowDate.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
      
        return rowDate >= startDate;
      });
      
      
    }
    if (filters.endDate) {
      filtered = filtered.filter((row) => {
        const rowDate = new Date(row.date);
        const endDate = new Date(filters.endDate);
      
        rowDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
      
        return rowDate <= endDate;
      });
      
      
    }
    if (filters.bank) {
      filtered = filtered.filter((row) => row.bank == filters.bank);
    }
    if (filters.customer) {
      filtered = filtered.filter((row) => row.paye == filters.customer);
    }
    if (filters.search) {
      filtered = filtered.filter(
        (row) =>
          row.description?.toLowerCase().includes(filters.search.toLowerCase()) ||
        row.voucher?.toLowerCase().includes(filters.search.toLowerCase()) ||
        row.cheque?.toLowerCase().includes(filters.search.toLowerCase()) 
      );
    }
    setFilteredCashbooks(filtered);
  }, [filters, transactions]);
  
  const finalBalance = filteredCashbooks.reduce((total, row) => {
    const amount = parseFloat(row.amount) || 0; 
    return row.type === 'income' ? total + amount : total - amount;
  }, 0);
  const calculateBalance = () => {
    let balance = 0;
    return filteredCashbooks.map((row) => {
      balance += row.type === 'income' ? parseFloat(row.amount) : - parseFloat(row.amount);
      return { ...row, balance };
    });
  };

  const customerOptions = [...new Set(transactions.map(res => res.paye))].map((cust) => {
    const supplier = allData?.suppliers.find(a => a.id == cust);
    return {
      value: cust,
      label: supplier?.name || cust,
    };
  });


  return (
    <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
      {/* Header */}
      <div className="flex w-full items-center justify-between">
        <h1 className="font-bold text-2xl flex items-center">
                          <FaReceipt className="mr-2" /> Receipts
                        </h1>
        <div className="flex items-center">

        <button 
           className="flex btn border border-blue-950 text-blue-950 items-center justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        onClick={()=>addPay(1, 1)}>
          <FaPlus/>
         Add Receipt</button>


        <button
          onClick={toggleModal}
          className="flex btn bg-blue-950  text-white items-center justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        >
          <FaPlus/>
          
          Add Customer
        </button>

       
   </div>
     
      </div>
      <hr className="my-3"/>

      
      <div id="allCust">

      <div className="grid grid-cols-3 gap-4 mb-4">
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.startDate}
          onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.endDate}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <select
          className="border px-3 py-2 rounded"
          value={filters.bank}
          onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
        >
          <option value="">All CashBooks</option>
          {allData?.bank?.map((bank) => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>

              <Select
        options={customerOptions}
        placeholder="Customers"
        isClearable
        value={customerOptions.find(option => option.value === filters.customer)}
        onChange={(selectedOption) =>
          setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
        }
      />
        <input
          type="text"
          placeholder="Search..."
          className="border px-3 py-2 rounded"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
      </div>

            <br />

<span className='text-gray-800 pt-5 text-small'>A list of my transactions</span>


     
      <DataTable
                title=""
                columns={columns}
                data={calculateBalance()}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={customStyles}
            />
 <div className="text-right font-bold mt-2">
             Balance: {formatToZMW(finalBalance)}
          </div>
      </div>

      {/* Sliding Div */}
      {showSlidingDiv && (
        <div
          id="slidingDiv"
          className="bg-white fixed top-0 right-0 h-full w-3/4 overflow-hidden shadow-lg"
        >
            <FaTimes 
                onClick={closeSlidingDiv}
                className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
            />
          
          <h3 className="m-2 font-semibold text-lg">{title}</h3>
          <hr />
          <button
                                onClick={() => handlePrint(componentRef)}
                                className="bg-blue-950 text-white px-4 py-2 rounded m-2"
                                >
                                <FaPrint/>
                                 </button>
          <div className="h-[90vh] overflow-auto" id="form">{output}</div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <form
            onSubmit={handleSubmit}
            className="bg-white min-h-[60vh] rounded p-5 w-[60%] mx-20 shadow-lg overflow-y-auto relative"
          >
            <div className="flex justify-between items-center mb-4 border-b pb-5">
              <h2 className="text-xl font-semibold">Add New Customer</h2>
              <button
                type="button"
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4">
             
              <input
                name="name"
                placeholder='First Name'
                value={formData.name}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="contactPerson"
                placeholder='Last Name'
                value={formData.contactPerson}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
             
            </div>

            <div className="mt-4 flex justify-end mt-10 pt-5 border-t col-span-2">
              <button
                type="button"
                onClick={toggleModal}
                className="bg-gray-100 hover:bg-gray-200 w-[150px] text-[13px] text-gray-700 font-semibold py-2 px-4 rounded"
              >
                Close
              </button>
              <button
                type="submit"
                className="bg-blue-950 hover:bg-blue-950/90 w-[150px] text-[13px] text-white font-bold py-2 px-4 rounded mx-2"
              >
                <i className="fa fa-paper-plane mr-2"></i>
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CustomerPage;
